"use client";
import { jsx } from "react/jsx-runtime";
import cx from "classnames";
const ModalBody = (props) => {
  const { prefix = "", children, className = "", ...other } = props;
  return /* @__PURE__ */ jsx("div", { ...other, className: cx(`${prefix}modal-body`, className), children });
};
var ModalBody_default = ModalBody;
export {
  ModalBody,
  ModalBody_default as default
};
